import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import H2 from '../../../commons/H2'
import H1 from '../../../commons/H1'
import Bold from '../../../commons/Bold'
import NativeSelect from '../../../commons/NativeSelect'
import P from '../../../commons/P'
import FormCollapsable from './FormCollapsable'
import FormLegend from './FormLegend'
import { useController, useForm } from 'react-hook-form'
import axios from 'axios'
import { baseUrl } from '../../../../config'
//@ts-ignore
import ReactRecaptcha3 from 'react-google-recaptcha3'
import { useNavigate } from 'react-router-dom'
import Select, { Options } from '../../../commons/Select'
import dreamIcon from '../../../../img/ico_dream.svg'
import identityIcon from '../../../../images/ico_identity.svg'
import moneyIcon from '../../../../images/ico_money.svg'
import timeIcon from '../../../../images/ico_time.svg'
import Loading from '../../../commons/Loading'
import { createCampaign } from '../../../helpers'
import {UtmsType} from "../../landingGenerale/LandingGenerale";

interface PreventivatoreProps {
  routeAfterSubmit?: string
  lpType?: string
  teadsConversionType?: string
}
type FormValues = {
  lp: string
  tipologia: string
  macroprofessione: string
  importo: string
  durata: string
  nome: string
  cognome: string
  annonascita: string
  citta: string
  provincia: string
  telefono: string
  email: string
  conferma_email: string
  p1: String
  p2: string
  p3: string
  reCaptchaToken: string
  utms: UtmsType
  campagna: any
}

const FormInput = (props: any) => {
  const { control, name, rules } = props
  const { field, fieldState: { error } } = useController({ control, name, rules })

  useEffect(() => {
    if (props.id) {
      const inputElem = document.getElementById('email-confirmation') as HTMLInputElement
      inputElem.setCustomValidity('')
    }
  }, [field, props.id])

  return (
    <InputContainer>
      <Input {...field} value={field.value || ''} aria-label={name} {...props} />
        {error && (
            <ErrorText>{error.message}</ErrorText>
        )}
    </InputContainer>
  )
}

const Preventivatore = ({
  routeAfterSubmit = '',
  lpType = '',
  teadsConversionType = ''
}: PreventivatoreProps) => {
  const navigate = useNavigate()

  const [teadsSent, setTeadsSent] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const areEqualEmails = (data: any) => {
    const emailConfirmationInput = document.getElementById('email-confirmation') as HTMLInputElement
    if (data.email !== data.conferma_email) {
      emailConfirmationInput && emailConfirmationInput.setCustomValidity('Gli indirizzi Email non combaciano.')
      emailConfirmationInput.reportValidity()
      return false
    } else {
      emailConfirmationInput && emailConfirmationInput.setCustomValidity('')
      return true
    }
  }

  const { register, handleSubmit, control, setValue } = useForm<FormValues>()
  const formSubmit = handleSubmit((data, event) => {
    if (!areEqualEmails(data)) return
    event?.preventDefault()
    setIsLoading(true)

    if (teadsConversionType) {
      //@ts-ignore
      const teads = window.teads_e
      if (teads && !teadsSent) {
        setTeadsSent(true)
        teads.push({
          conversionType: teadsConversionType
        })
      }
    }
    // data.utms = JSON.parse(localStorage.getItem('qp_utms') || "")

    ReactRecaptcha3.getToken().then(
      async (token: string) => {
        data.nome = data.nome.trim()
        data.cognome = data.cognome.trim()
        data.citta = data.citta.trim()
        data.telefono = data.telefono.trim()

        if(!data.nome || !data.cognome || !data.citta ||!data.telefono)  {
          console.error('Name, surname, city or phone number missing')
          setIsLoading(false)
          return
        }

        data.reCaptchaToken = token
        data.lp = lpType
        data.p1 = 'si'
        data.p2 = data.p2 ? 'si' : 'no'
        data.p3 = data.p3 ? 'si' : 'no'
        data.utms = JSON.parse(localStorage.getItem('qp_utms') || '{}')

        data.campagna = createCampaign(data.utms, lpType)

        await axios
          .post(`${baseUrl}/preventivatore-prestitopuoi`, data)
          .then(() => routeAfterSubmit && navigate(routeAfterSubmit))
          .catch((e) => {
            console.log('Error submitting', e.message)
            // TODO: mostrare modale di errore
          })
          .finally(() => setIsLoading(false))
      },
      (e: string) => {
        // TODO: mostrare modale errore
        setIsLoading(false)
        console.error('Error retrieving recaptcha token', e)
      }
    )
  })

  return (
    <Container>
      {isLoading && <Loading />}
      <FormContainer>
        <Form id={'preventivatore2'} onSubmit={formSubmit}>
          <FirstSection>
            <StyledH1>
                CERCHI UN PRESTITO PERSONALE? <br/>
                CON PRESTITOPUOI TROVI LA SOLUZIONE PIÙ ADATTA A TE
            </StyledH1>
            <StyledH2>RICHIEDI UN PREVENTIVO GRATUITO E SENZA IMPEGNO</StyledH2>
            <StyledP>
              <Bold>Compila subito il form.</Bold> Verrai ricontattato dai nostri consulenti per ricevere una proposta personalizzata.
            </StyledP>
            <StyledP>
                Il finanziamento è rivolto a clientela privata (a titolo esemplificativo e non esaustivo, dipendenti di società pubbliche e private, autonomi in p.iva, pensionati).
            </StyledP>
            <Row>
              <SelectContainer>
                <Select
                  isTextBold={true}
                  name={'tipologia'}
                  options={typeList}
                  placeHolderText={'IL MIO PROGETTO'}
                  icon={dreamIcon}
                  dataFromSelect={({ value }: any) => {
                    setValue('tipologia', value, { shouldDirty: true })
                  }}
                  control={control}
                />
              </SelectContainer>
              <SelectContainer>
                <Select
                  isTextBold={true}
                  name={'macroprofessione'}
                  options={customerCategoryList}
                  placeHolderText={'CHI SONO'}
                  icon={identityIcon}
                  dataFromSelect={({ value }: any) => {
                    setValue('macroprofessione', value, { shouldDirty: true })
                  }}
                  control={control}
                />
              </SelectContainer>
              <SelectContainer>
                <Select
                  isTextBold={true}
                  name={'importo'}
                  options={amountList}
                  placeHolderText={'IMPORTO*'}
                  icon={moneyIcon}
                  dataFromSelect={({ value }: any) => {
                    setValue('importo', value, { shouldDirty: true })
                  }}
                  control={control}
                />
              </SelectContainer>
              <SelectContainer>
                <Select
                  required={true}
                  isTextBold={true}
                  name={'durata'}
                  options={durationList}
                  placeHolderText={'DURATA*'}
                  icon={timeIcon}
                  dataFromSelect={({ value }: any) => {
                    setValue('durata', value, { shouldDirty: true })
                  }}
                  control={control}
                />
              </SelectContainer>
            </Row>
          </FirstSection>
          <SecondSection>
            <Row>
              <FormInput
                control={control}
                name={'nome'}
                type={'text'}
                id={'name'}
                placeholder={'Nome*'}
                rules={{ required: 'il campo Nome è obbligatorio' }}
              />
              <FormInput
                control={control}
                name={'cognome'}
                type={'text'}
                id={'surname'}
                placeholder={'Cognome*'}
                rules={{ required: 'il campo Cognome è obbligatorio' }}
              />
              <FormInput
                control={control}
                name={'annonascita'}
                type={'number'}
                id={'birthday'}
                placeholder={'Anno di nascita*'}
                min={'1919'}
                max={'2001'}
                rules={{ required: 'il campo Anno di nascita è obbligatorio' }}
              />
              <FormInput
                control={control}
                name={'citta'}
                type={'text'}
                id={'city'}
                placeholder={'Città*'}
                rules={{ required: 'il campo Città è obbligatorio' }}
              />
              <ProvinceSelectContainer>
                <NativeSelect
                  control={control}
                  rules={{ required: 'il campo Provincia è obbligatorio' }}
                  name={'provincia'}
                  options={provinceList}
                  placeHolderText={'Provincia*'}
                  dataFromSelect={(value) => {
                    setValue('provincia', value, { shouldDirty: true })
                  }}
                />
              </ProvinceSelectContainer>
              <FormInput
                control={control}
                name={'telefono'}
                type={'tel'}
                id={'telefono'}
                placeholder={'Telefono*'}
                minLength={8}
                rules={{ required: 'il campo Telefono è obbligatorio' }}
              />
              <FormInput
                control={control}
                name={'email'}
                type={'email'}
                id={'email'}
                placeholder={'Email*'}
                rules={{ required: 'il campo Email è obbligatorio' }}
              />
              <FormInput
                control={control}
                name={'conferma_email'}
                type={'email'}
                id={'email-confirmation'}
                placeholder={'Conferma Email*'}
                autocomplete={'new-password'}
                rules={{ required: 'il campo Conferma Email è obbligatorio' }}
              />
              <CollapsableContainer>
                <FormCollapsable />
              </CollapsableContainer>
              <CheckContainer>
                <CheckInnerContainer>
                  <Checkbox {...register('p2')} type={'checkbox'} id={'privacy'} />
                  <CheckboxLabel htmlFor={'privacy'}>
                    Desidero ricevere comunicazioni su iniziative promozionali curate dalla Banca e relative a prodotti
                    della Banca (compreso marketing diretto) o di società Terze, ivi compresa l’organizzazione di
                    eventi, anche attraverso sistemi automatizzati (sms, mms, fax e posta elettronica) – Finalità 3
                    lettera a) e c) dell’informativa privacy.
                  </CheckboxLabel>
                </CheckInnerContainer>
              </CheckContainer>
              <CheckContainer>
                <CheckInnerContainer>
                  <Checkbox {...register('p3')} type={'checkbox'} id={'marketing'} />
                  <CheckboxLabel htmlFor={'marketing'}>
                    Desidero ricevere comunicazioni informative o offerte promozionali da Terzi, anche attraverso
                    sistemi automatizzati (sms, mms, fax e posta elettronica), di loro prodotti o servizi - Finalità 3
                    lettera d) dell’informativa privacy.
                  </CheckboxLabel>
                </CheckInnerContainer>
              </CheckContainer>
            </Row>
            <Row>
              <SubmitContainer>
                <SubmitButton type={'submit'}>RICHIEDI PREVENTIVO GRATUITO**</SubmitButton>
              </SubmitContainer>
            </Row>
            <Row>
              <FormLegend />
            </Row>
          </SecondSection>
        </Form>
      </FormContainer>
    </Container>
  )
}

//region Data

const typeList: Options[] = [
  { label: 'Liquidità', value: 'Liquidita' },
  { label: 'Spese Mediche', value: 'Mediche' },
  { label: 'Consolidamento Debiti', value: 'Consolidamento' },
  { label: 'Computer / Hi-Tech', value: 'Hi-Tech' },
  { label: 'Acquisto Auto / Moto', value: 'Auto' },
  { label: 'Acquisto Mobili', value: 'Mobili' },
  { label: 'Acquisto / Ristrutturazione', value: 'Casa' },
  { label: 'Vacanze / Viaggi', value: 'Viaggi' },
  { label: 'Altri Progetti', value: 'Altro' }
]

const customerCategoryList: Options[] = [
  {
    label: 'Dipendente azienda SPA/SRL',
    value: 'Privato'
  },
  {
    label: 'Dipendente Pubblico/Statale',
    value: 'Pubblico-Statale'
  },
  {
    label: 'Pensionato INPS',
    value: 'Pensionato'
  },
  {
    label: 'Partita IVA/Autonomo',
    value: 'P.IVA e AUTONOMO'
  }
]

const amountList: Options[] = [
  {
    label: 'Fino a 5.000 €',
    value: '5000'
  },
  {
    label: 'Fino a 6.000 €',
    value: '6000'
  },
  {
    label: 'Fino a 7.000 €',
    value: '7000'
  },
  {
    label: 'Fino a 8.000 €',
    value: '8000'
  },
  {
    label: 'Fino a 9.000 €',
    value: '9000'
  },
  {
    label: 'Fino a 10.000 €',
    value: '10000'
  },
  {
    label: 'Fino a 15.000 €',
    value: '15000'
  },
  {
    label: 'Fino a 20.000 €',
    value: '20000'
  },
  {
    label: 'Fino a 25.000 €',
    value: '25000'
  },
  {
    label: 'Fino a 30.000 €',
    value: '30000'
  }
]
const durationList: Options[] = [
  {
    label: '12 rate',
    value: '12'
  },
  {
    label: '24 rate',
    value: '24'
  },
  {
    label: '36 rate',
    value: '36'
  },
  {
    label: '48 rate',
    value: '48'
  },
  {
    label: '60 rate',
    value: '60'
  },
  {
    label: '72 rate',
    value: '72'
  },
  {
    label: '84 rate',
    value: '84'
  }
]
const provinceList: Options[] = [
  { value: '', label: 'Provincia*' },
  { value: 'agrigento', label: 'Agrigento' },
  { value: 'alessandria', label: 'Alessandria' },
  { value: 'ancona', label: 'Ancona' },
  { value: 'aosta', label: 'Aosta' },
  { value: 'arezzo', label: 'Arezzo' },
  { value: 'ascoli-piceno', label: 'Ascoli Piceno' },
  { value: 'asti', label: 'Asti' },
  { value: 'avellino', label: 'Avellino' },
  { value: 'bari', label: 'Bari' },
  { value: 'barletta-andria-trani', label: 'Barletta-Andria-Trani' },
  { value: 'belluno', label: 'Belluno' },
  { value: 'benevento', label: 'Benevento' },
  { value: 'bergamo', label: 'Bergamo' },
  { value: 'biella', label: 'Biella' },
  { value: 'bologna', label: 'Bologna' },
  { value: 'bolzano', label: 'Bolzano' },
  { value: 'brescia', label: 'Brescia' },
  { value: 'brindisi', label: 'Brindisi' },
  { value: 'cagliari', label: 'Cagliari' },
  { value: 'caltanissetta', label: 'Caltanissetta' },
  { value: 'campobasso', label: 'Campobasso' },
  { value: 'carbonia-iglesias', label: 'Carbonia-Iglesias' },
  { value: 'caserta', label: 'Caserta' },
  { value: 'catania', label: 'Catania' },
  { value: 'catanzaro', label: 'Catanzaro' },
  { value: 'chieti', label: 'Chieti' },
  { value: 'como', label: 'Como' },
  { value: 'cosenza', label: 'Cosenza' },
  { value: 'cremona', label: 'Cremona' },
  { value: 'crotone', label: 'Crotone' },
  { value: 'cuneo', label: 'Cuneo' },
  { value: 'enna', label: 'Enna' },
  { value: 'fermo', label: 'Fermo' },
  { value: 'ferrara', label: 'Ferrara' },
  { value: 'firenze', label: 'Firenze' },
  { value: 'foggia', label: 'Foggia' },
  { value: 'forli-cesena', label: 'Forlì-Cesena' },
  { value: 'frosinone', label: 'Frosinone' },
  { value: 'genova', label: 'Genova' },
  { value: 'gorizia', label: 'Gorizia' },
  { value: 'grosseto', label: 'Grosseto' },
  { value: 'imperia', label: 'Imperia' },
  { value: 'isernia', label: 'Isernia' },
  { value: 'l-aquila', label: "L'Aquila" },
  { value: 'la-spezia', label: 'La Spezia' },
  { value: 'latina', label: 'Latina' },
  { value: 'lecce', label: 'Lecce' },
  { value: 'lecco', label: 'Lecco' },
  { value: 'livorno', label: 'Livorno' },
  { value: 'lodi', label: 'Lodi' },
  { value: 'lucca', label: 'Lucca' },
  { value: 'macerata', label: 'Macerata' },
  { value: 'mantova', label: 'Mantova' },
  { value: 'massa-e-carrara', label: 'Massa e Carrara' },
  { value: 'matera', label: 'Matera' },
  { value: 'medio-campidano', label: 'Medio Campidano' },
  { value: 'messina', label: 'Messina' },
  { value: 'milano', label: 'Milano' },
  { value: 'modena', label: 'Modena' },
  { value: 'monza-e-brianza', label: 'Monza e Brianza' },
  { value: 'napoli', label: 'Napoli' },
  { value: 'novara', label: 'Novara' },
  { value: 'nuoro', label: 'Nuoro' },
  { value: 'ogliastra', label: 'Ogliastra' },
  { value: 'olbia-tempio', label: 'Olbia-Tempio' },
  { value: 'oristano', label: 'Oristano' },
  { value: 'padova', label: 'Padova' },
  { value: 'palermo', label: 'Palermo' },
  { value: 'parma', label: 'Parma' },
  { value: 'pavia', label: 'Pavia' },
  { value: 'perugia', label: 'Perugia' },
  { value: 'pesaro-e-urbino', label: 'Pesaro e Urbino' },
  { value: 'pescara', label: 'Pescara' },
  { value: 'piacenza', label: 'Piacenza' },
  { value: 'pisa', label: 'Pisa' },
  { value: 'pistoia', label: 'Pistoia' },
  { value: 'pordenone', label: 'Pordenone' },
  { value: 'potenza', label: 'Potenza' },
  { value: 'prato', label: 'Prato' },
  { value: 'ragusa', label: 'Ragusa' },
  { value: 'ravenna', label: 'Ravenna' },
  { value: 'reggio-calabria', label: 'Reggio Calabria' },
  { value: 'reggio-emilia', label: 'Reggio Emilia' },
  { value: 'rieti', label: 'Rieti' },
  { value: 'rimini', label: 'Rimini' },
  { value: 'roma', label: 'Roma' },
  { value: 'rovigo', label: 'Rovigo' },
  { value: 'salerno', label: 'Salerno' },
  { value: 'sassari', label: 'Sassari' },
  { value: 'savona', label: 'Savona' },
  { value: 'siena', label: 'Siena' },
  { value: 'siracusa', label: 'Siracusa' },
  { value: 'sondrio', label: 'Sondrio' },
  { value: 'taranto', label: 'Taranto' },
  { value: 'teramo', label: 'Teramo' },
  { value: 'terni', label: 'Terni' },
  { value: 'torino', label: 'Torino' },
  { value: 'trapani', label: 'Trapani' },
  { value: 'trento', label: 'Trento' },
  { value: 'treviso', label: 'Treviso' },
  { value: 'trieste', label: 'Trieste' },
  { value: 'udine', label: 'Udine' },
  { value: 'varese', label: 'Varese' },
  { value: 'venezia', label: 'Venezia' },
  { value: 'verbano-cusio-ossola', label: 'Verbano Cusio Ossola' },
  { value: 'vercelli', label: 'Vercelli' },
  { value: 'verona', label: 'Verona' },
  { value: 'vibo-valentia', label: 'Vibo Valentia' },
  { value: 'vicenza', label: 'Vicenza' },
  { value: 'viterbo', label: 'Viterbo' }
]

//endregion

// region Style
const Container = styled.div`
  @media (min-width: 992px) {
    order: 2;
  }
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  width: 100%;
`
const FormContainer = styled.div`
  background: #fff;
  border-radius: 33px;
`
const Form = styled.form``
const FirstSection = styled.div`
  @media (min-width: 769px) {
    padding: 4rem 4rem 2rem 4rem;
  }
  background: #222;
  color: #fff;
  border-radius: 33px 33px 0 0;
  padding: 1.5rem;
  width: 100%;
  max-width: 114rem;
  transition: padding 0.1s ease-out;
  z-index: 10;
  :after {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 9px 9px 0 9px;
    border-color: #222222 transparent transparent transparent;
    content: '';
    display: block;
    left: 50%;
    bottom: -9px;
    transform: translateX(-50%);
  }
`
const SecondSection = styled.div`
  @media (min-width: 769px) {
    padding: 4rem;
  }
  padding: 1.5rem;
`
const StyledH2 = styled(H2)`
  @media (min-width: 769px) {
    font-size: 28px;
    letter-spacing: 1px;
  }
  font-size: 25px;
  letter-spacing: 0;
  margin-bottom: 2rem;
`
const StyledH1 = styled(H1)`
  @media (min-width: 769px) {
    font-size: 31px;
    letter-spacing: 1px;
  }
  font-size: 28px;
  letter-spacing: 0;
  margin-bottom: 2rem;
  color: #FFB500;
`
const StyledP = styled(P)`
  text-align: center;
  font-size: 19px;
  line-height: 1.3;
  letter-spacing: 0;
  margin-top: 2px;
`
const Row = styled.div`
  margin-right: -8px;
  margin-left: -8px;
  display: flex;
  flex-wrap: wrap;
`
const SelectContainer = styled.div`
  @media (min-width: 992px) {
    flex: 0 0 25%;
    max-width: 25%;
  }
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 1rem !important;
  width: 100%;
`
const ProvinceSelectContainer = styled.div`
  @media (min-width: 992px) {
    flex: 0 0 25%;
    max-width: 25%;
  }
  margin-bottom: 16px;
  padding-left: 8px;
  padding-right: 8px;
  width: 100%;
`
const CollapsableContainer = styled.div`
  @media (min-width: 992px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 1.5rem !important;
  width: 100%;
`
const SubmitContainer = styled.div`
  @media (min-width: 992px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
  padding-left: 8px;
  padding-right: 8px;
  text-align: center !important;
  width: 100%;
`
const CheckContainer = styled.div`
  text-align: left;
  padding-left: 8px;
  padding-right: 8px;
  @media (min-width: 992px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
  width: 100%;
`
const CheckInnerContainer = styled.div`
  display: block;
  padding-left: 1.25rem;
`
const Checkbox = styled.input<any>`
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
  box-sizing: border-box;
  padding: 0;
`
const CheckboxLabel = styled.label`
  text-align: initial;
  font-size: 9px;
  display: inline-block;
  margin-left: 8px;
`

const InputContainer = styled.div`
  @media (min-width: 992px) {
    flex: 0 0 25%;
    max-width: 25%;
  }
  margin-bottom: 16px;
  padding-left: 8px;
  padding-right: 8px;
  width: 100%;
`
const Input = styled.input`
  background: #e8e8e8;
  width: 100%;
  border: solid 1px #fff;
  color: #9b9b9b;
  font-weight: 700;
  font-family: TradeGothicLTPro, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  display: block;
  -webkit-appearance: none;
  line-height: 1;
  font-size: 1.3rem;
  border-radius: 2.3rem;
  min-height: 4.6rem;
  padding: 1rem 1.5rem;
  &:focus {
   outline: 3px solid #005fcc;
   outline-offset: 2px
  }
`
const SubmitButton = styled.button`
  background-image: linear-gradient(112deg, #fac963 0%, #eba918 51%, #fed033 100%);
  font-size: 16px;
  color: #fff;
  letter-spacing: 0;
  cursor: pointer;
  font-weight: 700;
  text-decoration: none;
  line-height: 1;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  transition: all 0.1s ease-out;
  border-radius: 2.3rem;
  min-height: 4.6rem;
  padding: 1rem 3rem;
  border: none;
`

const ErrorText = styled.div`
  color: black;
  font-weight: bold ;
  background-color: #FCBB00;
  border-radius: 0.7rem;
  padding: .4rem;
  line-height: 1.3rem;
  border: 1px solid black;
  font-size: 1.3rem;
  margin-top: .3rem;
`
// endregion

export default Preventivatore
